import { render, staticRenderFns } from "./IssueSelectionTable.vue?vue&type=template&id=33fc9835&scoped=true"
import script from "./IssueSelectionTable.vue?vue&type=script&lang=js"
export * from "./IssueSelectionTable.vue?vue&type=script&lang=js"
import style0 from "./IssueSelectionTable.vue?vue&type=style&index=0&id=33fc9835&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fc9835",
  null
  
)

export default component.exports